export default "__VITE_ASSET__D_ZG31Ry__"